import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class FenologiaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        
        if (Util.isNull(model.empresa)) {
            refs.empresaSelect.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.idCliente)) {
            refs.clienteSelect.focusedOut = true;
            validated = false;
        }
        
        if (Util.isNull(model.uuidPropriedade)) {
            refs.propriedadeSelect.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.uuidArea)) {
            refs.areaSelect.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.uuidTalhao)) {
            refs.talhaoSelect.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.idCultura)) {
            refs.culturaSelect.focusedOut = true;
            validated = false;
        }
        
        return validated;
    }

}